module.exports = __webpack_public_path__ + "img/basic-folder-icon.f7cc22e1.svg";